<template>
<b-navbar class="m-0 p-0">
  <button type="button" @click="$store.dispatch('toggleCollapseSidebar')" :class="{ collapsed: sidebarCollapsed }" variant="none" :aria-expanded="sidebarCollapsed ? 'true' : 'false'" class="collapse-toggler mx-3">
    <span class="icon-bar"></span>
    <span class="icon-bar"></span>
    <span class="icon-bar"></span>
  </button>
  <div class="align-items-center">
    <keep-alive>
      <component v-if="headerPlugins.left" :is="headerPlugins.left" />
    </keep-alive>
  </div>
  <div class="ml-auto align-items-center">
    <keep-alive>
      <component v-if="headerPlugins.center" :is="headerPlugins.center" />
    </keep-alive>
  </div>
  <b-navbar-nav class="ml-auto align-items-center" v-if="isAuthenticated">
    <div class="align-items-center">
      <keep-alive>
        <component v-if="headerPlugins.right" :is="headerPlugins.right" />
      </keep-alive>
    </div>
    <b-nav-item-dropdown right>
      <div class="arrow"></div>
      <template #button-content>
        <b-img rounded="circle" :src="profile.profile_picture" width="32" height="32" blank-color="#777" alt="img" class="" v-if="profile && profile.profile_picture" />
        <b-img rounded="circle" src="https://www.gravatar.com/avatar/default?s=100&r=pg&d=mm" width="32" height="32" blank-color="#777" alt="img" class="" v-else />
      </template>
      <b-dropdown-header>
        {{profile ? profile.name : ''}}<br>
        <small style="text-transform: uppercase;" v-if="profile && profile.company">{{profile.company.name}}</small>
      </b-dropdown-header>
      <hr class="my-2" v-if="env === 'local' || env === 'development'">
      <b-dropdown-header v-if="env === 'local' || env === 'development'">Language Test</b-dropdown-header>
      <label for="header-language-select" class="sr-only" v-if="env === 'local' || env === 'development'" v-translate>Language</label>
      <select id="header-language-select" name="language" v-model="$language.current" style="background: #fff; border: 0;" class="form-csontrol col-sm-12" v-if="env === 'local' || env === 'development'">
        <option v-for="(language, key) in $language.available" :key="key" :value="key">{{ language }}</option>
      </select>
      <hr class="my-2">
      <b-dropdown-item href="#" @click.prevent="logout()">
        <font-awesome-icon icon="sign-out-alt" size="1x" />&nbsp;&nbsp;<translate>Sign out</translate>
      </b-dropdown-item>
      <hr class="my-2" v-if="ecosystem.terms || ecosystem.privacy">
      <b-dropdown-item v-if="ecosystem.terms" :href="ecosystem.terms" class="small" target="_blank">
        <translate>Terms and Conditions</translate>
      </b-dropdown-item>
      <b-dropdown-item v-if="ecosystem.privacy" :href="ecosystem.privacy" class="small" target="_blank">
        <translate>Privacy Policy</translate>
      </b-dropdown-item>
    </b-nav-item-dropdown>
    <b-nav-item :href="ecosystem.helpUrl" target="_blank" class="no-border">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="34" viewBox="0 0 28 34">
        <g fill="none" fill-rule="evenodd">
          <circle cx="14" cy="17" r="12" stroke="#666" stroke-width="2" />
          <path fill="#666"
            d="M13.48 26c-.457 0-.856-.148-1.196-.443-.341-.296-.511-.71-.511-1.241 0-.472.164-.868.494-1.19.33-.322.733-.483 1.212-.483.472 0 .869.16 1.19.483.322.322.484.718.484 1.19 0 .524-.169.936-.506 1.235-.337.3-.726.449-1.168.449M8 13.694c0-.712.228-1.432.685-2.162.456-.73 1.123-1.334 1.999-1.813.875-.48 1.897-.719 3.065-.719 1.085 0 2.044.2 2.874.6.831.401 1.473.946 1.926 1.635.453.688.68 1.437.68 2.245 0 .637-.13 1.194-.388 1.673a5.125 5.125 0 0 1-.92 1.241 67.2 67.2 0 0 1-1.915 1.757 7.792 7.792 0 0 0-.612.612 2.483 2.483 0 0 0-.343.483 2.37 2.37 0 0 0-.174.438c-.04.146-.103.403-.185.77-.142.778-.588 1.167-1.336 1.167-.39 0-.717-.127-.983-.382-.265-.254-.398-.632-.398-1.134 0-.629.097-1.173.292-1.634.194-.46.453-.864.775-1.212a17.81 17.81 0 0 1 1.302-1.241c.479-.42.825-.735 1.039-.949a3.22 3.22 0 0 0 .539-.713c.146-.262.219-.546.219-.853 0-.6-.223-1.104-.668-1.516-.446-.412-1.02-.618-1.724-.618-.824 0-1.43.208-1.82.624-.388.415-.718 1.027-.987 1.835-.255.846-.738 1.27-1.449 1.27-.419 0-.773-.148-1.06-.444-.29-.296-.433-.616-.433-.96" />
          <g stroke="#4A4A4A">
            <path d="M-575.5-37.5h1290v148h-1290z" />
          </g>
        </g>
      </svg>
    </b-nav-item>
  </b-navbar-nav>
</b-navbar>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      env: process.env.ENV_FLAG
    }
  },
  computed: {
    // Fail-closed for restricted profiles: ecosystem plugins never render unless the
    // front_config whitelists them in plugins.restrictedVisible. Plugins may poll
    // endpoints the restricted role has no permission for (e.g. OrbcommLastUpdated
    // polls items every 15 min) and the global HTTP interceptor turns those 4xx into
    // ERROR dialogs — v-if false keeps the component unmounted, so nothing fires.
    headerPlugins() {
      // The header mounts with the layout BEFORE the router guard finishes
      // fetchProfile, so at that instant roles are empty and isRestrictedAccess is a
      // false negative: the plugin would mount, fire its first request (4xx → ERROR
      // dialog) and — being inside keep-alive — keep its polling timer alive even
      // after being hidden. Render no plugin until the profile is hydrated; roles are
      // committed in the same fetchProfile handler, so profile.id implies roles.
      if (!this.profile?.id) {
        return {}
      }
      const header = this.ecosystemPlugins?.header || {}
      if (!this.isRestrictedAccess) {
        return header
      }
      const visible = this.ecosystemPlugins?.restrictedVisible || []
      return Object.fromEntries(
        Object.entries(header).map(([slot, name]) => [slot, visible.includes(name) ? name : null])
      )
    }
  },
  methods: {
    logout() {
      this.$http.post(this.$appConfig.api.baseUrl + 'logout')
        .then(() => {
          this.$store.dispatch('logout')
            .then(() => {
              // TODO: clean up this quick & dirty store reset to avoid wrong ecosystemConfig when changing users
              window.location.reload()
            })
        })
    }
  }
}
</script>

<style lang="scss">
.collapse-toggler {
  display: block !important;
  height: 41px;
  border: 0;
  background-color: inherit;
  &[aria-expanded="true"] {
    height: 41px;
    .icon-bar:first-child {
      top: 0;
      animation: topbar-back 0.5s 0s;
      animation-fill-mode: forwards;
    }
    .icon-bar:nth-child(2) {
      opacity: 1;
    }
    .icon-bar:nth-child(3) {
      top: 0;
      animation: bottombar-back 0.5s 0s;
      animation-fill-mode: forwards;
    }
  }
  &[aria-expanded="false"] {
    .icon-bar:first-child {
      top: 6px;
      animation: topbar-x 0.5s 0s;
      animation-fill-mode: forwards;
    }
    .icon-bar:nth-child(2) {
      opacity: 0;
    }
    .icon-bar:nth-child(3) {
      bottom: 6px;
      animation: bottombar-x 0.5s 0s;
      animation-fill-mode: forwards;
    }
  }
}
</style>
